// ======================================================================
// File Name       : configFile
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/configFile';

const initialState = {
  downloadConfigFile: {
    recordNum: 0,
    userfrontDownloadResultList: [],
  },
  uploadConfigFile: {
    recordNum: 0,
    userfrontUploadResultList: [],
  },
};

export default function configFile(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_DOWNLOAD_CONFIG_FILE_RESULT: {
      const { recordNum, userfrontDownloadResultList } = action;
      const downloadConfigFile = {};
      downloadConfigFile.userfrontDownloadResultList = userfrontDownloadResultList;
      downloadConfigFile.recordNum = recordNum;
      return {
        ...state,
        downloadConfigFile,
      };
    }
    case ActionTypes.RESET_DOWNLOAD_CONFIG_FILE: {
      const downloadConfigFile = {
        recordNum: 0,
        userfrontDownloadResultList: [],
      };
      return {
        ...state,
        downloadConfigFile,
      };
    }
    case ActionTypes.GET_UPLOAD_CONFIG_FILE_RESULT: {
      const { recordNum, userfrontUploadResultList } = action;
      const uploadConfigFile = {};
      uploadConfigFile.userfrontUploadResultList = userfrontUploadResultList;
      uploadConfigFile.recordNum = recordNum;
      return {
        ...state,
        uploadConfigFile,
      };
    }
    case ActionTypes.RESET_UPLOAD_CONFIG_FILE: {
      const uploadConfigFile = {
        recordNum: 0,
        userfrontUploadResultList: [],
      };
      return {
        ...state,
        uploadConfigFile,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
